import { Controller } from "@hotwired/stimulus"

// Counts enquiries for Matomo without personal data. Every route someone uses
// to get in touch is mapped to a fixed name; the event carries that name and
// the page path, nothing typed or read from the address. Events are pushed to
// Matomo Tag Manager's data layer only after the visitor has accepted cookies
// (window.analyticsLoaded, set by partials/_analytics), so declining means
// nothing is queued, and nothing from before consent is sent later.
//
// The Tag Manager trigger, tag and goals that turn these into reports are set
// up in Matomo, not here: see the PR that added this file.
export const ROUTES = [
  [/^https:\/\/calendly\.com\/doorflow-intro(\/|\?|$)/, "calendly"],
  [/^https:\/\/doorflow\.typeform\.com\/to\/htAeNU(\/|\?|$)/, "contact-form"],
  [/^https:\/\/doorflow\.typeform\.com\/to\/X1XSxj(\/|\?|$)/, "quick-quote"],
  [/^mailto:hello@doorflow\.com(\?|$)/i, "email"],
  [/^tel:(\/\/)?\+44/, "phone-uk"],
  [/^tel:(\/\/)?\+1/, "phone-us"],
]

// The names a successful form submit can report, set by the controllers.
export const SENT = ["contact-sent", "invite-sent", "guide-sent"]

export function routeFor(href) {
  const match = ROUTES.find(([pattern]) => pattern.test(href || ""))
  return match ? match[1] : null
}

export default class extends Controller {
  static values = { sent: String }

  connect() {
    if (SENT.includes(this.sentValue)) this.push(this.sentValue)
  }

  track(event) {
    const link = event.target.closest && event.target.closest("a[href]")
    if (!link) return
    const route = routeFor(link.getAttribute("href"))
    if (route) this.push(route)
  }

  push(route) {
    if (!window.analyticsLoaded) return
    window._mtm = window._mtm || []
    window._mtm.push({ event: "enquiry", enquiryRoute: route, enquiryPage: window.location.pathname })
  }
}
